import React from "react";
import { useNavigate } from "react-router-dom";

export default function Terms() {
    const navigate = useNavigate();


    return (
        <main
            style={{
                padding: "60px 40px",
                maxWidth: "900px",
                margin: "70px auto",
                lineHeight: "1.7"
            }}
        >
            <h1>Terms of Use</h1>

            <p>
                By accessing and using this website, member portal, uploaded content,
                announcements, reports, calendar features, post feed, and Online Voting
                System (OVS), you agree to the following terms and conditions.
            </p>

            <h3>1. Authorized Use</h3>
            <p>
                This platform is intended for official use by members, officers,
                COMELEC users, administrators, and other authorized users of the
                Southern Alberta Regional Council Canada, Triskelions Grand Fraternity
                and Sorority.
            </p>
            <p>
                Unauthorized access, impersonation, account sharing, role abuse,
                attempts to bypass access controls, or misuse of the system is strictly prohibited.
            </p>

            <h3>2. Member Responsibility</h3>
            <p>
                Members are responsible for maintaining the confidentiality of their
                login credentials, temporary passwords, verification codes, OVS access,
                and authenticated browser sessions.
            </p>
            <p>
                Any activity performed using a member's account is presumed to be
                authorized by that member. Members must keep their profile, email address,
                and mobile number accurate where required for account recovery, voting,
                notices, and council records.
            </p>

            <h3>3. Online Voting System (OVS)</h3>
            <ul>
                <li>Voting access is limited to eligible members only</li>
                <li>Each member is permitted to vote once per election</li>
                <li>Members must provide accurate voter details and use only their own account, primary ID, email address, and verification code</li>
                <li>COMELEC officers and administrators may manage or monitor elections only within their assigned permissions</li>
                <li>
                    Attempts to manipulate, duplicate, or bypass voting controls
                    are strictly prohibited
                </li>
                <li>Attempts to interfere with vote verification, vote receipts, candidate totals, election schedules, or OVS password controls are strictly prohibited</li>
            </ul>
            <p>
                Election results, participation summaries, receipts, and audit records
                generated by the system are subject to official council or COMELEC validation.
            </p>

            <h3>4. Member Profiles and Submitted Content</h3>
            <p>
                Members and authorized users may create, update, upload, or interact with
                profile information, photos, reports, announcements, calendar responses,
                post feed content, comments, replies, reactions, and attachments.
            </p>
            <p>
                Users must not submit false, harmful, unlawful, offensive, confidential,
                malicious, copyrighted, or unauthorized content. Uploaded files must follow
                the file type and size limits enforced by the system.
            </p>

            <h3>5. Administrative Access</h3>
            <p>
                Administrators, COMELEC users, and officers with elevated access must use
                those permissions only for official council functions, including member
                management, reports, announcements, calendar administration, security review,
                and election administration.
            </p>
            <p>
                Administrative users must not access, alter, delete, export, or disclose
                information except where required for authorized duties.
            </p>

            <h3>6. Communications</h3>
            <p>
                The system may send account, password reset, contact form, announcement,
                voting verification, and vote confirmation messages. Users agree to provide
                accurate contact information and not misuse communication features.
            </p>

            <h3>7. System Availability</h3>
            <p>
                We strive to maintain system availability but do not guarantee
                uninterrupted or error-free operation.
            </p>
            <p>
                Maintenance, updates, or unforeseen technical issues may result in
                temporary service interruptions.
            </p>

            <h3>8. Security and Prohibited Conduct</h3>
            <p>
                Users must not attempt to disrupt the website, upload malicious files,
                scrape restricted data, test security without permission, overload the
                service, bypass authentication, tamper with stored records, or use the
                system for spam, harassment, fraud, or unauthorized automation.
            </p>

            <h3>9. Intellectual Property</h3>
            <p>
                All content, systems, designs, and software on this website are the
                property of the Council unless otherwise stated. Users retain responsibility
                for content they upload or submit and must have the right to provide it.
            </p>

            <h3>10. Privacy</h3>
            <p>
                Use of the system is also governed by the Privacy Policy, which explains
                how information is collected, used, stored, and protected.
            </p>

            <h3>11. Limitation of Liability</h3>
            <p>
                The Council shall not be liable for damages resulting from misuse,
                inaccurate user-provided information, unauthorized access, content submitted
                by users, election disruptions caused by prohibited conduct, or system
                interruptions beyond reasonable control.
            </p>

            <h3>12. Enforcement</h3>
            <p>
                Violations of these terms may result in account restriction, content removal,
                access revocation, election review, administrative action, or referral to the
                appropriate council authority.
            </p>

            <h3>13. Modifications</h3>
            <p>
                These terms may be updated at any time. Continued use of the system
                constitutes acceptance of the updated terms.
            </p>
            {/* ✅ CLOSE BUTTON */}
            <div style={{ marginTop: "40px", textAlign: "center" }}>
                <button
                    onClick={() => navigate("/")}
                    onMouseEnter={(e) => {
                        e.target.style.background = "rgba(218, 165, 32, 0.15)";
                        e.target.style.color = "#ffd700";
                        e.target.style.boxShadow = "0 0 10px rgba(218,165,32,0.4)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "transparent";
                        e.target.style.color = "goldenrod";
                        e.target.style.boxShadow = "none";
                    }}
                    style={{
                        padding: "10px 28px",
                        background: "transparent",
                        color: "goldenrod",
                        border: "1px solid goldenrod",
                        borderRadius: "6px",
                        fontSize: "0.95rem",
                        cursor: "pointer",
                        transition: "all 0.25s ease"
                    }}
                >
                    Close
                </button>
            </div>
        </main>
    );
}
